<div>
  <div class="header-style">
    <div class="total-number">
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageIndex]="pageNumber - 1" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30, 100]" (page)="handlePage($event)"></mat-paginator>
      <mat-icon data-testid="add_user_button" (click)="addUser()" class="cursor add-icon" svgIcon="add" aria-hidden="false" i18n-label="@@addUserIcon"></mat-icon>
      
      @if (usersList.length > 0) {
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item (click)="exportChildren(1)" i18n="@@exportCsv">Export as CSV</button>
          <button mat-menu-item (click)="exportChildren(2)" i18n="@@exportPdf">Export as PDF</button>
          <button mat-menu-item (click)="exportChildren(3)" i18n="@@exportExcel">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" [matMenuTriggerFor]="exportMenu" i18n-label="@@exportIcon"></mat-icon>
      }
      
      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field>
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input data-testid="users_search_input" i18n-placeholder="@@searchPlaceholder" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon class="cursor search-icon" data-testid="users_clear_button" matSuffix (click)="clearSearch()" i18n-label="@@clearSearchIcon">clear</mat-icon>
          </mat-form-field>
        }
      </form>

      <mat-icon data-testid="users_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-label="@@searchIcon"></mat-icon>
    </div>
  </div>

  <div class="cards-container">
    @for (item of usersList; track item; let itemIndex = $index) {
      <mat-card class="tall-box card">
        <mat-card-content>
          <img (click)="editUser(item.id, item)" class="cursor" [src]="item.picturePath" (error)="img.src = imageSrc" #img i18n-alt="@@userAvatarAlt" alt="User Avatar">
          <div class="content-box">
            <div (click)="editUser(item.id, item)" class="flex-grow cursor">
              <div class="mat-subtitle-1 margin-bottom truncate" matTooltip ellipsisTooltip>{{item.firstName}} {{item.lastName}}</div>
              <div class="mat-caption truncate" matTooltip ellipsisTooltip>{{item.email}}</div>
            </div>
            <mat-icon data-testid="delete_user_button" (click)="deleteUser(item.id)" color="warn" class="cursor" i18n-label="@@deleteUserIcon">delete_outline</mat-icon>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>

  @if (usersList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-alt="@@emptyViewImgAlt" alt="Empty View">
  }
</div>